import { useState } from 'react';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import activityLogService from '../../service/activityLog.service';
import { dataGridPremiumColumns } from '../../utils/helper';
import dayjs from 'dayjs';

export const ActivityLogTable = () => {
  const [logs, setLogs] = useState({ rows: [], rowCount: 0 });
  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'operation', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 100,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getList = (gridState) => {
    activityLogService.getRows(gridState).then((res) => {
      setLogs(res);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'operation',
      headerName: 'Művelet',
      type: 'string',
    },
    {
      field: 'description',
      headerName: 'Leírás',
      type: 'string',
    },
    {
      field: 'createdAt',
      headerName: 'Létrehozás dátuma',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.createdAt);
      },
      renderCell: (data) => {
        return dayjs(data.row.createdAt).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'createdBy',
      headerName: 'Létrehozó felhasználó',
      type: 'string',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.activityLogTable}
      datagridInitialState={initialState}
      dataLoader={getList}
      paginationAndfilterMode="server"
      height={window.innerHeight - 100}
      columns={columns}
      rows={logs.rows}
      rowCount={logs.rowCount}
      onCellDoubleClick={(_params, event) => {
        event.defaultMuiPrevented = true;
      }}
      getRowHeight={() => 'auto'}
    />
  );
};
